/* LDS VIN name translator.
   The VIN boxes (Search by Vehicle + homepage, liftgate finder, subwoofer box finder) look a VIN up
   with the US government's NHTSA service. NHTSA uses US model names and its own spellings
   ("Mazda3", "330i", "GLC-Class", "Rogue Sport"); vehicle-fitment.csv uses ours ("3", "3 Series",
   "GLC", "Qashqai"). Every VIN box asks this one file for the names to try, so a fix here fixes all
   of them. To add a mismatch, add a line to ALIAS: 'nhtsa-name': ['our-name'], both written as
   lower-case-with-dashes (the way the page addresses are written).
   Loaded from layout/theme.liquid. Re-add that line after a theme update. */
(function () {
  'use strict';
  if (window.LDSVin) return;

  function slug(s) { return String(s || '').toLowerCase().replace(/&/g, '').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  // NHTSA make -> our make
  var MAKE = { 'mercedes': 'mercedes-benz', 'mercedes-benz-sprinter': 'mercedes-benz' };

  // Per make: NHTSA model -> our model(s), tried in order. Heavy-duty trucks map to the base name so the
  // VIN's series (2500 / 3500) picks the right one.
  var ALIAS = {
    'nissan': { 'rogue-sport': ['qashqai'] },
    'mitsubishi': { 'outlander-sport': ['rvr'], 'rvr': ['outlander-sport'] },
    'mercedes-benz': { 'm-class': ['ml'], 'ml-class': ['ml'] },
    'land-rover': { 'range-rover-evoque': ['evoque'], 'range-rover-velar': ['velar'], 'lr2': ['freelander-2'], 'lr4': ['discovery-4'] },
    'mini': { 'hardtop': ['cooper'] },
    'volkswagen': { 'gti': ['golf-gti', 'golf'], 'golf-gti': ['golf'], 'r32': ['golf'], 'rabbit': ['golf'], 'gli': ['jetta'] },
    'toyota': { 'corolla-matrix': ['matrix'], 'gr86': ['86'] },
    'mazda': { 'mx-5': ['mx-5-miata'] },
    'subaru': { 'xv-crosstrek': ['crosstrek'], 'b9-tribeca': ['tribeca'] },
    'hyundai': { 'elantra-touring': ['i30'] },
    'infiniti': { 'jx35': ['qx60'], 'ex35': ['ex35-ex37'], 'ex37': ['ex35-ex37'], 'q70l': ['q70'] },
    'ford': { 'e-100': ['e-series'], 'e-150': ['e-series'], 'e-250': ['e-series'], 'e-350': ['e-series'], 'e-450': ['e-series'], 'e-550': ['e-series'], 'f-150-heritage': ['f-150'] },
    'chevrolet': { 'silverado-ld': ['silverado-1500'], 'silverado-ltd': ['silverado-1500'], 'silverado-hd': ['silverado'], 'bolt-ev': ['bolt'], 'bolt-euv': ['bolt'] },
    'gmc': { 'sierra-limited': ['sierra-1500'], 'sierra-hd': ['sierra'] },
    'chrysler': { 'town-and-country': ['town-country'] },
    'honda': { 'crosstour': ['accord-crosstour'] }
  };

  // Rules for whole families of names, used when the exact name and ALIAS don't match.
  function ruleNames(mk, md) {
    var out = [], m;
    if (mk && md.indexOf(mk) === 0 && md.length > mk.length) out.push(md.slice(mk.length).replace(/^-/, '')); // Mazda3 -> 3, Nissan Z -> z
    if (/-class$/.test(md)) out.push(md.replace(/-class$/, ''));                                          // GLC-Class -> glc
    if (mk === 'bmw') {
      if ((m = /^m?(\d)\d\d[a-z]*$/.exec(md))) out.push(m[1] + '-series');                                // 330i, M340i -> 3 Series
      else if ((m = /^m(\d)$/.exec(md))) out.push(m[1] + '-series');                                      // M3 -> 3 Series
      else if (md === '1m') out.push('1-series');
      else if ((m = /^(?:activehybrid|alpina-b)-?(\d)$/.exec(md))) out.push(m[1] + '-series');           // ActiveHybrid 5, Alpina B7
    }
    if (mk === 'infiniti' && (m = /^([a-z]+)\d\d[a-z]?$/.exec(md))) out.push(m[1]);                        // G37 -> g, FX35 -> fx, M37 -> m
    if (mk === 'audi') {
      if ((m = /^r?s-?(\d)$/.exec(md))) out.push('a' + m[1]);                                              // S4, RS 5 -> A4, A5
      else if ((m = /^sq(\d)$/.exec(md))) out.push('q' + m[1]);                                            // SQ5 -> Q5
      else if (md === 'tts' || md === 'tt-rs') out.push('tt');
      else if (md === 'allroad' || md === 'a4-allroad') out.push('a4');
    }
    if (md.indexOf('-and-') > 0) out.push(md.replace(/-and-/g, '-'));                                     // Town and Country -> Town & Country
    return out;
  }

  // alts(make, model) -> [{ mk, md }] in the order to try. The exact NHTSA names always come first,
  // so a vehicle that already matched keeps matching exactly as before.
  function alts(make, model) {
    var mk = slug(make), md = slug(model), list = [], seen = {};
    function add(a, b) { if (a && b && !seen[a + '|' + b]) { seen[a + '|' + b] = 1; list.push({ mk: a, md: b }); } }
    add(mk, md);
    var ourMk = MAKE[mk] || mk;
    add(ourMk, md);
    // Scion: NHTSA files Scion VINs under Toyota as "Scion tC"; the 2017-18 Corolla iM was the Scion iM.
    if (ourMk === 'toyota' && md.indexOf('scion-') === 0) add('scion', md.slice(6));
    if (ourMk === 'toyota' && md === 'corolla-im') add('scion', 'im');
    // Older Sprinters were sold as Dodge and Freightliner.
    if ((ourMk === 'dodge' || ourMk === 'freightliner') && md === 'sprinter') add('mercedes-benz', 'sprinter');
    ((ALIAS[ourMk] || {})[md] || []).forEach(function (n) { add(ourMk, n); });
    ruleNames(ourMk, md).forEach(function (n) { add(ourMk, n); ((ALIAS[ourMk] || {})[n] || []).forEach(function (x) { add(ourMk, x); }); });
    return list;
  }

  window.LDSVin = { alts: alts, slug: slug };
})();
